import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { HowItWorks } from './components/HowItWorks';
import { Features } from './components/Features';
import { IngredientDemo } from './components/IngredientDemo';
import { Testimonials } from './components/Testimonials';
import { DownloadCTA } from './components/DownloadCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <HowItWorks data-id="element-4" />
        <Features data-id="element-5" />
        <IngredientDemo data-id="element-6" />
        <Testimonials data-id="element-7" />
        <DownloadCTA data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}